import React, { Component } from 'react';
import { Route } from 'react-router';

import Home from './components/Home'
import DashBoard from './components/DashBoard';
import Layout  from './components/Layout';
import Recordings from './components/recordings/RecordingsDash'
import Activities from './components/acitivities/ActivitiesDash'
import Account from './components/account/AccountDash';
import Logs from './components/logdata/LogDash'
import AdminDash  from './components/administrator/AdminDash';
import CheckRefresh from './components/CheckRefresh';


//import AuthorizeRoute from './components/api-authorization/AuthorizeRoute';

//import ApiAuthorizationRoutes from './components/api-authorization/ApiAuthorizationRoutes';
//import { ApplicationPaths } from './components/api-authorization/ApiAuthorizationConstants';

import './custom.css'

class App extends Component {
 // static displayName = App.name;


  
  render () {


    return (
      <Layout>
        <CheckRefresh />
        <Route exact path='/:vID' component={Home}  />
        <Route path='/home' render={(props) => <DashBoard {...props} />}  />
        <Route path='/recordings' render={(props) => <Recordings {...props} />}  />
        <Route path='/activities' render={(props) => <Activities {...props} />}  />
        <Route path='/logs' render={(props) => <Logs {...props} />}  />
        <Route path='/user' render={(props) => <AdminDash {...props} />}  />
        <Route path='/account' render={(props) => <Account {...props} />}  />
       
      </Layout>
    );
  }
}

export default App
